<template lang="html">
  <div class="modal-card">

    <header class="modal-card-head">
      <p class="modal-card-title">Create a publication</p>
    </header>

    <section class="modal-card-body">
      Which picture do you want to use ?<em>Not yet implem</em>
    </section>

    <footer class="modal-card-foot">

      <span class="card-footer-item">
        <b-button @click="$parent.close()">
          Close
        </b-button>
      </span>

      <span class="card-footer-item">
        <b-button @click="publish" type="is-success" icon-pack="mdi" icon-right="check">
            Publish
        </b-button>
      </span>

    </footer>
  </div>
</template>

<script>
export default {
  props: ['publishable', 'publishable_type'],
  methods: {
    publish () {
      this.$store.dispatch('publications/create', { publishable_id: this.publishable.id, publishable_type: this.publishable_type })
        .then(resp => {
          this.$buefy.toast.open({
            message: 'Publication created!',
            type: 'is-success'
          })
          this.$parent.close()
        })
        .catch(error => {
          // TODO: Handle error
          console.log(error.response.data)
        })
    }
  }
}
</script>

<style lang="css" scoped>
</style>
